// import JS files
import '../kickstart';
import './ballot-sticky-nav-bar';

import { h, render } from 'preact';
import loadJsonScript from '../utils/load-json-script';

// Components
import App from '../Ballot';

const notes = loadJsonScript('notes_data');

render(<App notes={notes} />, document.getElementById('app'));

if (process.env.NODE_ENV === 'development') {
  require('preact/debug');
}
